module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._v("\n\tDISPLAY\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aff9ddc0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Transactions/MyTransactions/Display.vue
// module id = 1165
// module chunks = 0